// extracted by mini-css-extract-plugin
export var anchor = "_2z-0";
export var discard = "_2z-4";
export var muiTooltipTooltip = "_2z-6";
export var notificationBar = "_2z-3";
export var saveButtonHoverSlotWrapper = "_2z-5";
export var show = "_2z-2";
export var spacer = "_2z-1";